import { useCallback } from "react";
import { spaDefaultAuthProviderState } from "./AuthProviderState.js";
import { useReauthenticate } from "./useReauthenticate.js";
const useLogIn = (authImplementation, setAuthProviderState, getCurrentUser) => {
  const reauthenticate = useReauthenticate(
    authImplementation,
    setAuthProviderState,
    getCurrentUser
  );
  return useCallback(
    async (options) => {
      setAuthProviderState(spaDefaultAuthProviderState);
      const loginResult = await authImplementation.login(options);
      await reauthenticate();
      return loginResult;
    },
    [authImplementation, reauthenticate, setAuthProviderState]
  );
};
export {
  useLogIn
};
